/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { STORE_PAUSED_STATE, CLEAR_PAUSED_STATE } from 'redux/actions/pause_status';

/* ========== ~~~~~~~~~~ PAUSE STATUS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const pauseStatus = (state = {}, action) => {
    switch (action.type) {
        case STORE_PAUSED_STATE:
            let newState = JSON.parse(JSON.stringify(state));
            return Object.assign({}, newState, action.pauseState);
        case CLEAR_PAUSED_STATE:
            newState = JSON.parse(JSON.stringify(state));
            delete newState[action.stateId];
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default pauseStatus;